module.exports = __webpack_public_path__ + "img/camera_down_code.ae4cfe98.png";